import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import EditProcessesForm from './EditProcessesForm'
import ProcessesLoader from './_load/ProcessesLoader'
import { PermissionChecker } from '../../session'
import ModalHeader from './ModalHeader'

const EditProcessesModal = props => {
  return (
    <ControlledModal width="32rem" disableClickOutside {...props}>
      <PermissionChecker permission={'setupScreen'}>
        <ProcessesLoader>
          <ModalHeader />
          <EditProcessesForm />
        </ProcessesLoader>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default EditProcessesModal
